import { isString } from 'es-toolkit/compat';

import { CompressedJsonParam } from 'utils/customQueryParamsConfigs';

export const markerChannelHistogramsQueryParam = 'markerChannelHistograms';

export type MarkerChannelHistogramState = Record<string, Record<number, boolean>>;

export const encodeMarkerChannelHistograms = ({
  markerTypes,
  viewerIndex = 0,
}: {
  markerTypes: string[];
  viewerIndex?: number;
}) => {
  const normalizedMarkerTypes = Array.from(new Set(markerTypes.filter(Boolean)));

  if (!normalizedMarkerTypes.length) {
    return null;
  }

  const encodedValue = CompressedJsonParam.encode(
    normalizedMarkerTypes.reduce<MarkerChannelHistogramState>((histogramState, markerType) => {
      histogramState[markerType] = {
        [viewerIndex]: true,
      };

      return histogramState;
    }, {})
  );

  return isString(encodedValue) ? encodedValue : null;
};

export const updateMarkerChannelHistogramState = (
  currentState: MarkerChannelHistogramState | undefined,
  histogramStateKey: string,
  viewerIndex: number,
  nextIsOpen: boolean
) =>
  CompressedJsonParam.encode({
    ...(currentState || {}),
    [histogramStateKey]: {
      ...currentState?.[histogramStateKey],
      [viewerIndex]: nextIsOpen,
    },
  });
